// extracted by mini-css-extract-plugin
export default {"modal":"UserDeal_modal__rLbeW","container":"UserDeal_container__zBJmg","selectTabs":"UserDeal_selectTabs__5VENz","selectTabItem":"UserDeal_selectTabItem__+GJha"};